import type { MetricCardProps } from "@go-novus/ui";

import * as m from "#/paraglide/messages";
import { getLocale } from "#/paraglide/runtime";

/**
 * 颜色跟的是好坏，不是涨跌：绿=好、红=坏，按美国市场的惯例来，
 * 不是国内股市那套红涨绿跌。Human backstop 涨了是坏事，所以它和另外两张反着看。
 */
export type MetricTone = NonNullable<MetricCardProps["deltaTone"]>;

const countFormat = new Intl.NumberFormat(getLocale());
const rateFormat = new Intl.NumberFormat(getLocale(), {
  maximumFractionDigits: 1,
  style: "percent",
});
const countChangeFormat = new Intl.NumberFormat(getLocale(), {
  signDisplay: "exceptZero",
});
const pointChangeFormat = new Intl.NumberFormat(getLocale(), {
  maximumFractionDigits: 1,
  signDisplay: "exceptZero",
});

export function formatCount(value: number): string {
  return countFormat.format(value);
}

/** 归属判定完成的会话为 0 时后端给 null，卡上留一个破折号而不是 0%。 */
export function formatRate(value: number | null): string {
  return value === null
    ? m.home_metric_value_unavailable()
    : rateFormat.format(value);
}

export function formatCountChange(change: number | null): string {
  return change === null
    ? m.home_metric_change_unavailable()
    : m.home_metric_change_count({ change: countChangeFormat.format(change) });
}

/** 比率的变化按百分点显示：契约里的 0.025 就是 +2.5 pt。 */
export function formatRateChange(change: number | null): string {
  return change === null
    ? m.home_metric_change_unavailable()
    : m.home_metric_change_points({
        change: pointChangeFormat.format(change * 100),
      });
}

export function readChangeTone(change: number | null): MetricTone {
  if (change === null || change === 0) {
    return "flat";
  }

  return change > 0 ? "good" : "bad";
}

/** Human backstop 涨了说明转人工变多，对商家是坏消息，所以变化值反着看。 */
export function readInvertedChangeTone(change: number | null): MetricTone {
  return readChangeTone(change === null ? null : -change);
}
